"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDueDateFieldValue = exports.getDueDateFieldEmptyValue = void 0;
const get_value_1 = require("../date-range-field/get-value");
const getDueDateFieldEmptyValue = () => ({
    ...(0, get_value_1.getDateRangeFieldEmptyValue)(),
    status_updated_on: null,
    status_is_completed: false,
});
exports.getDueDateFieldEmptyValue = getDueDateFieldEmptyValue;
const generateDueDateFieldValue = (value) => {
    return { ...(0, exports.getDueDateFieldEmptyValue)(), ...value };
};
exports.generateDueDateFieldValue = generateDueDateFieldValue;
